interface IProps {
  block?: Ref<HTMLElement | undefined>
  offset?: Ref<number>
  showFirst?: boolean
}

export function useAnimateSticky({ block, offset, showFirst }: IProps) {
  const { isConciergeDialogOpen } = useConcierge();

  const sticky = ref(false);
  const hideSticky = ref(false);
  const windowEl = ref<Window | null>(null);

  const { y, directions } = useScroll(windowEl);

  const offsetComp = computed(() => {
    if (offset?.value) return offset.value;
    if (!block?.value) return null;

    return block.value.offsetTop + block.value.offsetHeight;
  });

  let isFirstWay = true;
  let isProcessing = false;

  function hideStickyF() {
    isProcessing = true;
    hideSticky.value = true;

    return new Promise((resolve) => {
      setTimeout(() => {
        sticky.value = false;
        hideSticky.value = false;
        isProcessing = false;

        resolve(true);
      }, 200);
    });
  }

  function showFirstF() {
    if (isFirstWay) {
      isProcessing = true;
      sticky.value = true;

      setTimeout(async () => {
        await hideStickyF();
        isFirstWay = false;
      }, 3000);

      return;
    }

    if (sticky.value) {
      hideStickyF();
    }
  }

  watchDebounced(directions, (value) => {
    if (!offsetComp.value || isProcessing) return;

    if (y.value < offsetComp.value && !isConciergeDialogOpen.value) {
      isFirstWay = true;

      if (offset && value.top && sticky.value) {
        hideStickyF();
      }
      return;
    }

    if (value.bottom) {
      if (showFirst) {
        showFirstF();
        return;
      }

      if (sticky.value) {
        hideStickyF();
      }
    }

    if (value.top) {
      sticky.value = true;
    }
  }, { debounce: 200 });

  onMounted(() => {
    windowEl.value = window;
  });

  return {
    sticky,
    hideSticky,
  };
}
